import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Button, Inline } from 'chaoskit/src/components';
import { directoryUrl } from 'chaoskit/src/helpers/utility';
import { merge } from 'lodash-es';

import { Data } from '../../../components';
import amazon from '../../../assets/media/logo-amazon-white.svg';
import netflix from '../../../assets/media/logo-netflix-white.svg';
import salesforce from '../../../assets/media/logo-salesforce-white.svg';

const TeamIntro = ({ cta, heading }) => {
  const {
    file: { childDataYaml: pageData },
  } = useStaticQuery(graphql`
    query TeamIntroPageData {
      file(name: { eq: "index-LEGACY" }) {
        childDataYaml {
          team {
            heading
            cta {
              label
              url
            }
          }
        }
      }
    }
  `);

  // Combine pageData and props passed in to get proper values
  const mergedData = merge(pageData.team, { cta, heading });

  // If we have both an cta.onClick prop and cta.url prop; remove cta.url prop since onClick is the outlier
  if (mergedData.cta && mergedData.cta.onClick && mergedData.cta.url) {
    mergedData.cta.url = null;
  }

  return (
    <section className="section section--large u-contrast u-gradient--darkBlue-purple">
      <div className="container">
        <div className="section-titleWrapper">
          <h3 className="section-title">
            <Data>{mergedData.heading}</Data>
          </h3>
        </div>
        <Inline className="company-logos u-flexCenter" size="xlarge">
          <img className="company-logos--amazon" src={amazon} alt="Amazon" />
          <img src={netflix} alt="Netflix" />
          <img src={salesforce} alt="SalesForce" />
        </Inline>
        {mergedData.cta && (
          <div className="u-mt--xlarge u-textCenter">
            <Button
              onClick={mergedData.cta.onClick && mergedData.cta.onClick}
              url={mergedData.cta.url && directoryUrl(mergedData.cta.url)}
              type="default"
            >
              <Data>{mergedData.cta.label}</Data>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

TeamIntro.propTypes = {
  cta: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    onClick: PropTypes.func,
  }),
  heading: PropTypes.string,
};

TeamIntro.defaultProps = {
  cta: {},
};

export default TeamIntro;
